export default {
  value: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    default: () => String('KPI'),
  },
  creationDate: {
    type: Array,
  },
  creationDateTrends: {
    type: Array,
  },
  ...[
    'languagesList',
    'qaMethodsList',
    'qaModelsList',
    'textCategoryList',
    'industryFieldList',
    'reportTypeList',
  ].reduce((acc, key) => {
    acc[key] = {
      type: Array,
      required: true,
    };
    return acc;
  }, Object()),
};
